export interface ISearchRequestBase {
  page: number
  pageSize: number
}

export class SearchRequestBase implements ISearchRequestBase {
  public page: number
  public pageSize: number
}
